import { memo, useEffect, useState } from "react"
import { useApp } from "../../contexts/AppContext"
import { IOrder } from "sierra"
import { Avatar, Badge, Button, Divider, Grid2, Typography, useTheme } from "@mui/material"
import Container from "../Container"
import { useNavigate } from "react-router-dom"
import { useAuth } from "../../hooks/useAuth"
import api from "../../utils/axios"

const OrderCard = memo(({ order }: { order: Required<IOrder> }) => {
    const { lang, translate } = useApp()
    const { user } = useAuth()
    const navigate = useNavigate()
    const theme = useTheme()

    const [paying, setPaying] = useState(false)

    const service = order.service
    // const branch = order.branch
    const customer = order.customer
    const employee = order.employee
    const requestPayment = !order.is_cancelled && !order.order_paid && user?.role === 'customer';

    useEffect(() => console.log(
        order.order_details.filter(od => od.step_status === 'pending').length
    ), [])

    useEffect(() => console.log(order), [order])

    const handlePayment = (order_id: number) => {
        setPaying(true)
        api.get('/payments/paymentUrl/' + order_id).then(({ data }) => {
            window.location.href = data.url
        }).catch(console.error).finally(() => setPaying(false))
    }

    return (
        <Grid2 size={'grow'} minWidth={{ xs: '100%', lg: '13vw' }} maxWidth={'18vw'}>
            <Badge sx={{ width: '100%' }} badgeContent={user?.role === 'customer' ? order.order_details.filter(od => od.step_status === 'pending').length : 0} color="error">

                <Container container size={'grow'} flexDirection={'column'} borderRadius={2} overflow={'hidden'} bgcolor={'white'} sx={{
                    '&:hover': {
                        transform: 'translateY(-10px)',
                    },
                    transition: 'transform 0.4s ease'
                }}>
                    <Grid2 height={'15vh'} padding={'5%'} sx={{
                        backgroundImage: `url(${service.service_header_url})`,
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                    }}>

                        <Grid2 container display={'flex'} justifyContent={'space-between'}>
                            <Grid2>
                                {customer.avatar_url ?
                                    <img src={customer.avatar_url} style={{ width: '3vw', height: '3vw', borderRadius: 50 }} /> :
                                    <Avatar sx={{ width: '3vw', height: '3vw' }}>{customer.name[0]}</Avatar>
                                }
                            </Grid2>
                            {employee &&
                                <Grid2>
                                    {employee.avatar_url ?
                                        <img src={employee.avatar_url} style={{ width: '3vw', height: '3vw', borderRadius: 50 }} /> :
                                        <Avatar sx={{ width: '3vw', height: '3vw' }}>{employee.name[0]}</Avatar>
                                    }
                                </Grid2>
                            }
                        </Grid2>

                    </Grid2>
                    <Grid2 container size={'grow'} justifyContent={'space-between'} flexDirection={'column'} zIndex={2} padding={2} spacing={1}>
                        <Grid2>
                            <Typography variant='h6' color='primary' fontWeight={'bold'}>{service.service_name[lang]}</Typography>
                        </Grid2>
                        <Divider flexItem sx={{ backgroundColor: t => t.palette.primary.main }} />
                        <Grid2 container flexDirection={'column'}>
                            <Grid2>
                                <Typography variant='h6' sx={{ color: t => t.palette.secondary.dark }} fontWeight={'bold'}>{order.order_amount_total / 100} {translate("SAR")}</Typography>
                            </Grid2>
                            <Grid2 container flexDirection={'column'}>
                                <Grid2 display={requestPayment ? 'flex' : 'none'}>
                                    <Button disabled={paying} onClick={() => handlePayment(order.order_id)} fullWidth variant="contained" color="info" sx={{ fontWeight: 'bold' }}>
                                        {translate("Proceed to Pay")}
                                    </Button>
                                </Grid2>
                                <Grid2>
                                    <Button fullWidth variant="contained" color="secondary" onClick={() => navigate('manage?order_id=' + order.order_id)} sx={{
                                        backgroundImage: order.is_cancelled || order.order_status === 'completed' ? undefined : `linear-gradient(45deg, ${theme.palette.secondary.main}, ${theme.palette.secondary.dark})`, // Gradient
                                        backgroundColor: order.is_cancelled ? theme.palette.error.main : order.order_status === 'completed' ? theme.palette.success.main : undefined,
                                        backgroundSize: '200% 200%', // Initial size for the gradient
                                        color: 'white',
                                        fontWeight: 'bold',
                                        '&:hover': {
                                            backgroundPosition: '100% 0%', // Rotate the background gradient by changing position
                                        },
                                        transition: 'all 0.5s ease-in-out', // Transition for background position
                                    }}
                                    >
                                        {order.is_cancelled || order.order_status === 'completed' ? translate('View Order') : translate('Manage Order')} {order.order_status === 'completed' && `(${translate("Completed")})`} {order.is_cancelled && `(${translate("Cancelled")})`}
                                    </Button>
                                </Grid2>
                            </Grid2>
                        </Grid2>
                    </Grid2>
                </Container>
            </Badge>
        </Grid2 >
    )
})

export default OrderCard